
































































import { Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import { Action, Getter } from "vuex-class";
import Owner from "@/model/cospirit-api/Owner";
import OwnerSelect from "@/components/OwnerSelect.vue";
import Auth from "front-component/Auth";
import SwitchUser from "@/components/user/SwitchUser.vue";
import ShowUserAdmin from "@/components/user/ShowUserAdmin.vue";
import Notification from "@/components/notification/Notification.vue";
import NavigationMenu from "@/components/NavigationMenu.vue";

@Component({ components: {Notification, OwnerSelect, SwitchUser, ShowUserAdmin, NavigationMenu }})
export default class Header extends Vue {
    @Getter("getCurrentOwner") public currentOwner!: Owner;
    @Getter("getOwners") public owners!: Owner[];
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;
    @Action("changeCurrentOwner") protected changeCurrentOwner!: (uuid: string) => Promise<void>;
    @Getter("getUserDepartment") public userDepartment!: string;
    @Getter("getCurrentFeatures") public currentFeatures!: any;
    @Getter("getCurrentUser") public currentUser!: any;

    private get accessTokenAdmin(): string|null {
        return localStorage.getItem("access_token_admin");
    }

    private get isMultiOwners() {
        return "" !== this.userDepartment;
    }

    private get accessHomepage(): boolean {
        return this.hasFeature("HOMEPAGE") && !_.some(this.currentUser.userHideFeatures, (line) => {
            return line.code === "HIDE_HOMEPAGE";
        });
    }

    private changeOwner(uuid: string): void {
        this.changeCurrentOwner(uuid).then(() => {
            // Verify if owner can use the current page/feature
            if (this.hasFeature(_.get(this.$route, "meta.feature", ""))) {
                return;
            }

            // Otherwise go to other page/feature !
            const query = {};
            if ("home" === this.$route.name) {
                _.set(query, "sid", uuid);
            }
            this.$router
                .push({ name: "redirect", query })
                .catch(() => {
                    // Don't show navigation error
                    console.warn("Navigation on the same page with same parameters");
                });
        });
    }

    private disconnect(): void {
        if (!confirm(_.invoke(this.$options.filters, "trans", "confirmLogOut"))) {
            return ;
        }
        Auth.disconnect();
        localStorage.setItem("access_token_admin", "");
        this.$router.go(0);
    }
}
